import addNamespaces from '../translations/add-namespaces';
import en from '../translations/components/en.json';
import nl from '../translations/components/nl.json';

// deep=true so app-specific keys are merged into the namespace that
// addUiLibraryTranslations already seeded with ui-library defaults.
addNamespaces('components', { en, nl }, true);
